import React from 'react';
import { Navbar } from 'react-bootstrap';

const Footer = () => (
  <Navbar className='footer'>
    <p>&copy; 2026 Reyzap Solutions Pvt. Ltd. All rights reserved.</p>
  </Navbar >
);

export default Footer;